export function PrivacyPolicy() {
  return (
    <div className="h-full w-full overflow-y-auto bg-gradient-to-br from-indigo-950 via-gray-900 to-slate-900">
      <div className="max-w-2xl mx-auto px-6 py-12 text-white/80">
        <h1 className="text-2xl font-bold text-white mb-6">Privacy Policy</h1>
        <p className="text-sm mb-4">Last updated: September 11, 2026</p>

        <div className="space-y-5 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-semibold mb-2">1. What this app is</h2>
            <p>
              Shadow Cloud Code is a personal cloud coding workspace. It provides a browser-based
              remote desktop with a terminal, code editor and AI assistant, and syncs your
              project files with your own Google Drive account.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-2">2. What data we access</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong className="text-white">Your Google account email</strong> — to identify you and restrict access to approved accounts only.</li>
              <li><strong className="text-white">Google Drive files</strong> — limited to the <code className="text-white/90">MyCloudProjects</code> folder structure the app creates in your Drive. We read, create, modify and delete files only inside the project folders you sync.</li>
            </ul>
            <p className="mt-2">
              We request the Google Drive scope only so the app can store <em>your</em> code in
              <em> your</em> Drive on your behalf. We never read unrelated files from your Drive.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-2">3. What we do NOT do</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>We do not sell, share or transfer your data or Drive contents to anyone.</li>
              <li>We do not use your Drive data for advertising or model training.</li>
              <li>We do not allow human access to your file contents except to sync the files you choose.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-2">4. Storage &amp; retention</h2>
            <p>
              Project files live in your own Google Drive (permanent copy) and on the app
              server's workspace disk (temporary working copy, automatically re-pulled from
              Drive on server restarts). OAuth tokens are stored server-side and are deleted
              when you sign out and disconnect the app from your Google Account
              (myaccount.google.com → Security → Third-party apps with account access).
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-2">5. Your control</h2>
            <p>
              You can revoke the app's access at any time from your
              Google Account security settings, and delete any file directly from
              Google Drive or from within the app.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-2">6. Contact</h2>
            <p>Questions: <a className="underline" href="mailto:mrupala89@gmail.com">mrupala89@gmail.com</a></p>
          </section>
        </div>

        <a href="/" className="inline-block mt-10 text-xs text-white/50 underline hover:text-white/80">
          ← Back to Shadow Cloud Code
        </a>
      </div>
    </div>
  );
}
